import { render } from "./ConsultationRecordHeader.vue?vue&type=template&id=4f260e59&scoped=true"
import script from "./ConsultationRecordHeader.vue?vue&type=script&lang=js"
export * from "./ConsultationRecordHeader.vue?vue&type=script&lang=js"

import "./ConsultationRecordHeader.vue?vue&type=style&index=0&id=4f260e59&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f260e59"]])

export default __exports__